import { render } from "./AddMenuItem.vue?vue&type=template&id=0c6e0aaa"
import script from "./AddMenuItem.vue?vue&type=script&lang=js"
export * from "./AddMenuItem.vue?vue&type=script&lang=js"

import exportComponent from "/Users/wouter/Vue-apps/BRGR/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__